var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loadingState == "empty"
    ? _c("div", { staticClass: "alert alert-warning" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("label.no_user_input")) + "\n"),
      ])
    : _vm.loadingState == "loading"
    ? _c("div", { staticClass: "text-center alert alert-info" }, [
        _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
        _vm._v("\n    " + _vm._s(_vm.$t("label.searching_articles")) + "\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }